import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { DeleteNewsletterRequest } from './delete-newsletter.request';

@Injectable({ providedIn: 'root' })
export class DeleteNewsletterUseCase extends UseCase<DeleteNewsletterRequest, Observable<HttpResponse<any>>> {
    private _apiRequestService = inject(ApiRequestService);
    private _emailBaseUrl = inject<string>('EMAIL_BACKEND_URL' as any);
    private _deleteEmailTemplateUrl = '/admin/deleteEmailTemplate';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: DeleteNewsletterRequest | void
    ): Observable<HttpResponse<any>> | void {
        return this._apiRequestService.sendRequest<DeleteNewsletterRequest, HttpResponse<any>>(
            this._emailBaseUrl,
            request as DeleteNewsletterRequest,
            true,
            this._deleteEmailTemplateUrl
        );
    }
}
